module.exports = __webpack_public_path__ + "static/media/YF28_2.47d951e1.jpg";